export interface RibbonTuning {
  cameraDistanceDesktop: number
  cameraDistanceMobile: number
  constraintIterations: number
  fabricStrength: number
  guideStiffness: number
  progressDamping: number
  shadowOpacity: number
  simulationDamping: number
  turbulenceAmplitude: number
  turbulenceScale: number
  turbulenceSpeed: number
}

export const RIBBON_CONFIG = {
  colors: {
    atmosphere: '#9fb6b7',
    ribbon: '#ece9dc',
    shadow: '#5e7477',
  },
  geometry: {
    joints: 128,
    length: 11.8,
    lengthSegments: 256,
    thickness: 0.16,
    thicknessSegments: 2,
    width: 1.85,
    widthSegments: 12,
  },
  camera: {
    fov: 34,
    near: 0.1,
    far: 80,
    focusY: 0,
    mobileAspectBreakpoint: 0.72,
    mobileRotation: Math.PI * 0.5,
  },
  light: {
    position: [4.5, 6.5, 9] as const,
    shadowBias: -0.00035,
    shadowBounds: 15,
    shadowMapSize: 2048,
    shadowNormalBias: 0.035,
    shadowPlaneDepth: -2.55,
  },
  material: {
    ambient: 0.4,
    fabricRepeat: [48, 22] as const,
    lightDirection: [0.52, 0.38, 0.76] as const,
    normalMapSize: 128,
    specularPower: 24,
  },
  motion: {
    gravity: -0.08,
    maxDelta: 1 / 30,
    scrollScreens: 5,
    substeps: 2,
  },
  renderer: {
    desktopDprCap: 1.5,
    exposure: 1.08,
    mobileDprCap: 1.25,
    mobileWidthBreakpoint: 600,
  },
  tuning: {
    cameraDistanceDesktop: 13.7,
    cameraDistanceMobile: 21,
    constraintIterations: 8,
    fabricStrength: 0.27,
    guideStiffness: 190,
    progressDamping: 5.4,
    shadowOpacity: 0.13,
    simulationDamping: 0.82,
    turbulenceAmplitude: 0.11,
    turbulenceScale: 0.52,
    turbulenceSpeed: 0.055,
  } satisfies RibbonTuning,
} as const

export const createRibbonTuning = (): RibbonTuning => ({
  ...RIBBON_CONFIG.tuning,
})
